module.exports = __webpack_public_path__ + "img/11.0a225dc7.jpg";